import { NG_VALIDATORS, UntypedFormControl, ValidationErrors, Validator } from '@angular/forms';
import { Directive, Input } from '@angular/core';
import { CategoryListItem } from '../models/category-list-item.model';

@Directive({
    selector: '[appProhibitedCategoryValidator]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: ProhibitedCategoryValidatorDirective,
            multi: true,
        },
    ],
})
// todo: check it, maybe rename
export class ProhibitedCategoryValidatorDirective implements Validator {
    @Input() categoriesList: CategoryListItem[];
    @Input() currentCategoryIndex: number;

    validate(field: UntypedFormControl): ValidationErrors | null {
        if (field.value) {
            const hasChildCategory = !!this.categoriesList[this.currentCategoryIndex + 1]?.categories?.length;
            const isValid = field.value.isClickable || hasChildCategory;

            if (!isValid) {
                return {
                    validateCategory: {
                        invalid: true,
                    },
                };
            }
        }

        return null;
    }
}
